import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import StickySocial from '../components/StickySocial';
import { ChevronDown, Play } from 'lucide-react';
import {
  PillarsSection, WorkflowSection, FeaturesSection,
} from '../components/HomeSections';
import {
  FAQSection, NewsletterSection, TeamSection, AwardsSection,
} from '../components/HomeSections2';

export default function Home() {
  return (
    <>
      <Header />
      <StickySocial />

      {/* HERO */}
      <section
        id="top"
        className="relative h-screen min-h-[640px] max-h-[900px] flex items-start justify-center overflow-hidden"
        style={{
          backgroundImage:
            'linear-gradient(180deg, rgba(12,36,58,0.65) 0%, rgba(12,36,58,0.55) 45%, rgba(12,36,58,0.35) 75%, rgba(12,36,58,0.2) 100%), url(/img/header.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center 30%',
        }}
      >
        <div className="relative max-w-4xl mx-auto px-5 text-center text-white pt-32 md:pt-36 pb-16">
          <p className="text-sm md:text-base uppercase tracking-[0.3em] text-white/90 font-semibold mb-5 animate-fade-up drop-shadow-lg">
            Der Outdoor-Tresor
          </p>
          <h1 className="text-4xl md:text-6xl font-heading font-extrabold leading-tight animate-fade-up drop-shadow-[0_4px_14px_rgba(0,0,0,0.5)]">
            Diesen Sommer hast du endlich{' '}
            <em className="not-italic text-white underline decoration-spin-green-light decoration-[6px] underline-offset-[10px] whitespace-nowrap">
              #einesorgeweniger
            </em>
          </h1>
          <hr className="section-divider light" />
          <p className="text-base md:text-lg text-white leading-relaxed max-w-2xl mx-auto mb-8 animate-fade-up drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]">
            Endlich brauchst du dir um deine Wertsachen auf der Liegewiese keine Sorgen mehr zu
            machen. Ob am See, im Freibad, im Park oder auf dem Festival: der Spinsafe schützt
            Handy, Geld und Schlüssel zuverlässig vor Gelegenheitsdieben.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center animate-fade-up">
            <a
              href="#video"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 bg-spin-green hover:bg-spin-green-dark text-white font-semibold rounded-md uppercase tracking-wide text-sm transition-colors shadow-lg"
            >
              <Play size={16} /> Video ansehen
            </a>
            <a
              href="#workflow"
              className="inline-flex items-center justify-center px-7 py-3 border-2 border-white text-white font-semibold rounded-md uppercase tracking-wide text-sm hover:bg-white hover:text-spin-dark transition-colors shadow-lg backdrop-blur-sm bg-white/5"
            >
              So funktioniert's
            </a>
          </div>
        </div>

        <a
          href="#intro"
          className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/90 hover:text-white animate-bounce drop-shadow-lg"
          aria-label="Mehr erfahren"
        >
          <ChevronDown size={32} />
        </a>
      </section>

      {/* INTRO */}
      <section id="intro" className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-5 text-center">
          <p className="text-lg md:text-xl text-spin-dark leading-relaxed">
            Und zwar zweifach: Neben dem festen Halt in der Liegewiese bietet die{' '}
            <strong>Spinsafe-App</strong> digitale Sicherheitsfeatures wie einen schrillen Alarm.
            So sind Handy, Geld und Schlüssel zuverlässig vor Gelegenheitsdieben geschützt.
          </p>
        </div>
      </section>

      {/* VIDEO */}
      <section id="video" className="py-20 bg-spin-dark text-white">
        <div className="max-w-5xl mx-auto px-5">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-heading font-extrabold">
              Spinsafe im Einsatz
            </h2>
            <hr className="section-divider light" />
          </div>
          <div className="relative aspect-video w-full overflow-hidden rounded-lg shadow-2xl bg-black">
            <iframe
              src="https://player.vimeo.com/video/344421378?title=0&byline=0&portrait=0"
              title="Spinsafe im Einsatz"
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      <PillarsSection />
      <WorkflowSection />
      <FeaturesSection />
      <FAQSection />
      <NewsletterSection />
      <TeamSection />
      <AwardsSection />
      <Footer />
    </>
  );
}
